import Auth from '../modules/Authentication'
import { handleErrors, handleResponse } from '../modules/Utils'
import { apiUrl } from '../variables/index'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class DocumentsApi {
  constructor() {
    this.auth = new Auth()
  }

  actions = (id, status) => {
    if (status) {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}documents/actions?id=${id}&status=${status}`, {
        headers,
      })
        .then(handleErrors)
        .then(handleResponse)
    } else return []
  }

  link = (id, status) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}documents/link?id=${id}&status=${status}`, {
      headers,
    })
      .then(handleErrors)
      .then(handleResponse)
  }
}
